
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/articles/[slug]",
      function () {
        return require("private-next-pages/health-insurance/articles/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/articles/[slug]"])
      });
    }
  